export const POINTS_CREATE_REQUEST = "POINTS_CREATE_REQUEST"
export const POINTS_DELETE_REQUEST = "POINTS_DELETE_REQUEST"
export const POINTS_UPDATE_REQUEST = "POINTS_UPDATE_REQUEST"
export const POINTS_DETAILS_REQUEST = "POINTS_DETAILS_REQUEST"
export const GET_POINTS_REQUEST = "GET_POINTS_REQUEST"
export const GET_MY_POINTS_HISTORY_REQUEST = "GET_MY_POINTS_HISTORY_REQUEST"
export const GET_LEADERBOARD_POINTS_REQUEST = "GET_LEADERBOARD_POINTS_REQUEST"
export const GET_ALL_TIME_LEADERBOARD_POINTS_REQUEST = "GET_ALL_TIME_LEADERBOARD_POINTS_REQUEST"
export const MY_POINTS_OVERVIEW_REQUEST = "MY_POINTS_OVERVIEW_REQUEST"



